<kendo-dropdownlist
  defaultItem="Select Year"
  [itemDisabled]=""
  [data]="yearsArr"
  [valuePrimitive]="true"
  [(ngModel)]="selectedYear"
   (selectionChange) ="emitSelectedValue($event)"
></kendo-dropdownlist>
